import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { ShopType } from 'interfaces';

export type ShopInformation = {
  shop_information_id?: number; // 쇼/브/매/지 idx
  store_information?: { [key: string]: Record<string, any> }; // 매장정보
  mall_information?: { [key: string]: Record<string, any> }; // 쇼핑몰 정보
  shop_information_name?: string; // 쇼/브/매/지 명
  shop_information_content?: string; // 쇼/브/매/지 설명
  shop_information_address?: string; // 쇼/브/매/지 주소
  shop_information_address_detail?: string; // 쇼/브/매/지 상세주소
  application_status?: string; // 입점신청여부
  correction_status?: string; // 수정신청여부
  edit_information?: { [key: string]: Record<string, any> }; // 수정정보
  latitude: number; // 위도
  longitude: number; // 경도
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
  type?: (typeof ShopType)[keyof typeof ShopType]; // 타입
  organization_id?: number; // 조직 ID
  commission_rate?: number; // 수수로율
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ShopInformation
   * --
   */
  getShopInformations: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SHOP, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ShopInformation
   * --
   */
  getShopInformation: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      if (!idx) throw new Error('정보를 가져올 수 없습니다.');
      const url = parameterToPath(APIConstant.GET_SHOP, {
        shop_information_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ShopInformation
   * --
   */
  createShopInformation: async (body: ShopInformation) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SHOP, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ShopInformation
   * --
   */
  updateShopInformation: async (body: ShopInformation) => {
    try {
      const { shop_information_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SHOP, {
        shop_information_id: shop_information_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ShopInformation
   * --
   */
  deleteShopInformation: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SHOP, {
        shop_information_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
